import React from "react";
import { bool, string } from "prop-types";

import { useOHBehavior } from "../../../../redux/hooks/openHousesHooks";
import * as S from "./styled";

const PastOpenHouseActions = props => {
  const { confirmOHAttendance } = useOHBehavior();
  return (
    <S.Wrapper>
      {props.hasAnswer ? (
        <S.InfoBox role="alert">Thank you!</S.InfoBox>
      ) : (
        <S.InfoBox>
          Did you attend?
          <S.ActionButton
            aria-label="Did you attend? Yes"
            onClick={() =>
              confirmOHAttendance(props.savedOHId, true, props.openHouseId)
            }
          >
            Yes
          </S.ActionButton>
          <S.ActionButton
            aria-label="No"
            onClick={() =>
              confirmOHAttendance(props.savedOHId, false, props.openHouseId)
            }
          >
            No
          </S.ActionButton>
        </S.InfoBox>
      )}
    </S.Wrapper>
  );
};

PastOpenHouseActions.propTypes = {
  hasAnswer: bool,
  openHouseId: string,
  savedOHId: string
};

PastOpenHouseActions.defaultProps = {
  hasAnswer: false,
  openHouseId: "",
  savedOHId: ""
};

export default PastOpenHouseActions;
